import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApMessageService } from 'webcommon/messages';
import { ApBaseClass } from 'webcommon/shared';
import {
  CreateFacilityPortalMessageDto,
  FacilityPortalReplyMessageDto,
  FpMessageCreatedDto,
  FpMessagesCountsResultDto,
  FpMessagesReceivedDto,
  FpMessagesUrgencyDto,
  FpMessageTypeAndSuTypeParamsDto,
  FpReceivedMessageParamsDto,
  FpThreadMessageDto,
  MessageSubTypeDto,
} from 'webcommon/shared';
import { FpMessagesRepository } from 'webcommon/webapi';

@Injectable()
export class FacilityPortalMessageService extends ApBaseClass implements ApMessageService {
  constructor(
    private fpMessagesRepository: FpMessagesRepository,
  ) {
    super();
  }

  getMessageSubTypesForMessageType(messageTypeAndSubTypeParams: FpMessageTypeAndSuTypeParamsDto[]): Observable<MessageSubTypeDto[]> {
    return this.fpMessagesRepository.getMessageSubTypesForMessageType(messageTypeAndSubTypeParams);
  }

  getMessageCounts(messageTypeId: string, urgencyLimit: number): Observable <FpMessagesCountsResultDto[]> {
    return this.fpMessagesRepository.getMessageCounts(messageTypeId, urgencyLimit);
  }

  getMessageUrgencies(urgencyLimit: number): Observable<FpMessagesUrgencyDto[]> {
    return this.fpMessagesRepository.getMessageUrgencies(urgencyLimit);
  }

  postMessage(requestDto: CreateFacilityPortalMessageDto): Observable <FpMessageCreatedDto> {
    return this.fpMessagesRepository.postMessage(requestDto);
  }

  postReplyMessage(requestDto: FacilityPortalReplyMessageDto): Observable<FpMessageCreatedDto> {
    return this.fpMessagesRepository.postReplyMessage(requestDto);
  }

  postCompleteMessage(requestDto: FacilityPortalReplyMessageDto): Observable<FpMessageCreatedDto> {
    return this.fpMessagesRepository.postCompleteMessage(requestDto);
  }

  getReceivedMessages(rcvMsgParams: FpReceivedMessageParamsDto): Observable<FpMessagesReceivedDto[]> {
    return this.fpMessagesRepository.getReceivedMessages(rcvMsgParams);
  }

  getMessageThread(messageId: string): Observable<FpThreadMessageDto[]> {
    return this.fpMessagesRepository.getMessageThread(messageId);
  }

  setMessagesRead(messageId: string, threadLength: number): Observable<string> {
    return this.fpMessagesRepository.setMessagesRead(messageId, threadLength);
  }
}
